var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-pane fade",class:{ 'show': _vm.isActive, 'active': _vm.isActive },attrs:{"id":_vm.contentId,"role":"tabpanel","aria-labelledby":_vm.tabId}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }